import { Combobox, Transition } from "@headlessui/react";
import { ChevronDownIcon, PlusIcon } from "@heroicons/react/24/outline";
import { Fragment, useEffect, useRef, useState } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
export default function LocalCombobox(props: any) {
  const {
    data,
    props: otherProps,
    errors,
    setValue,
    register,
    name,
    getValues,
    clearErrors,
    disabled = false,
    value = null,
  } = props;

  const [query, setQuery] = useState("");
  const comboboxButtonRef = useRef<HTMLButtonElement>(null);
  const [selected, setSelected] = useState<any>(value);

  const filteredData: any =
    query === ""
      ? data
      : data.filter((item: any) =>
          item?.name
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(query.toLowerCase().replace(/\s+/g, ""))
        );

  useEffect(() => {
    setValue(name, selected ?? null);
  }, [selected]);

  useEffect(() => {
    if (selected && !value) {
      setSelected("");
    }
  }, [value]);

  return (
    <>
      <Combobox value={selected} disabled={disabled} onChange={setSelected}>
        <div className={tw`relative mt-2`}>
          <label>{props?.label}</label>

          <div
            className={tw`relative w-full cursor-default overflow-hidden  bg-white text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm mt-1`}
          >
            <Combobox.Input
              className={tw`w-full focus:outline-none bg-[#EEF5F4] p-[8px] text-left product-type-input-select`}
              placeholder={props?.placeholder}
              autoComplete="off"
              onBlur={() => clearErrors(name)}
              onKeyDown={(e: any) => {
                if (e.key === "Tab" && !e.shiftKey && !e?.target?.value) {
                  e.preventDefault();
                }
              }}
              displayValue={(person: any) => person?.name}
              onChange={(event) => setQuery(event.target.value)}
              onClick={() => {
                comboboxButtonRef?.current?.click();
              }}
            />
            <Combobox.Button
              ref={comboboxButtonRef}
              className={tw`absolute inset-y-0 right-0 flex items-center pr-2`}
            >
              {selected && (
                <PlusIcon
                  className={tw`h-5 w-5 text-gray-400 rotate-45`}
                  aria-hidden="true"
                  onClick={() => setSelected("")}
                />
              )}
              <ChevronDownIcon
                className={tw`h-5 w-5 text-gray-400`}
                aria-hidden="true"
              />
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setQuery("")}
          >
            <Combobox.Options
              className={tw`absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm`}
            >
              {filteredData?.length === 0 && query !== "" ? (
                <div
                  className={tw`relative cursor-default select-none py-2 px-4 text-gray-700`}
                >
                  Nothing found.
                </div>
              ) : (
                filteredData?.map((person: any, index: number) => (
                  <Combobox.Option
                    key={index}
                    className={({ active }) =>
                      tw`relative cursor-default select-none py-2 pl-10 pr-4 ${
                        active ? tw`bg-primary text-white` : tw`text-gray-900`
                      }`
                    }
                    value={person}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={tw`block truncate ${
                            selected ? tw`font-medium` : tw`font-normal`
                          }`}
                        >
                          {person.name}
                        </span>
                        {selected ? (
                          <span
                            className={tw`absolute inset-y-0 left-0 flex items-center pl-3 ${
                              active ? tw`text-white` : tw`text-teal-600`
                            }`}
                          >
                            {/* <CheckIcon className="h-5 w-5" aria-hidden="true" /> */}
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
          {errors && (
            <p className={tw`text-red-500 text-xs my-1`}>{errors?.message}</p>
          )}
        </div>
      </Combobox>
    </>
  );
}
